export default {
  state: {
    isFullScreenEnterBefore: false // 进入风险态势模块之前是否全盘

  },
  mutations: {
    // 更改状态
    SET_ENTER_BEFORE_SCREEN_STATE: function SET_ENTER_BEFORE_SCREEN_STATE(state, payload) {
      state.isFullScreenEnterBefore = payload;
    }
  },
  actions: {}
};